import { __assign } from "tslib";
import { createHttpTestKit } from '../../http/test-kit';
import { createFakePostResponder } from '../../test-utils';
import { createChatInsightsApi } from './';
export var createChatInsightsApiTestkit = function (parent) {
    if (parent === void 0) { parent = 'localhost'; }
    var fakeHttp = createHttpTestKit();
    var api = createChatInsightsApi(parent, fakeHttp);
    var base = "".concat(parent, "/analytics/chat");
    var handler = {
        whenGetOverview: createFakePostResponder(fakeHttp, "".concat(base, "/overview")),
        whenGetNumericComparison: createFakePostResponder(fakeHttp, "".concat(base, "/overviewTables/chat")),
        whenGetServedChatHistogram: createFakePostResponder(fakeHttp, "".concat(base, "/servedChats/histogram")),
        whenGetServedChatCumuative: createFakePostResponder(fakeHttp, "".concat(base, "/servedChats/cumulative")),
        whenGetTimeToEndChatHistogram: createFakePostResponder(fakeHttp, "".concat(base, "/timeToEndChat/histogram")),
        whenGetTimeToEndChatCumuative: createFakePostResponder(fakeHttp, "".concat(base, "/timeToEndChat/cumulative")),
        whenGetNewChatsHistogram: createFakePostResponder(fakeHttp, "".concat(base, "/newChats/histogram")),
        whenGetNewChatsCumuative: createFakePostResponder(fakeHttp, "".concat(base, "/newChats/cumulative")),
        whenGetFirstResponseTimeHistogram: createFakePostResponder(fakeHttp, "".concat(base, "/firstResponseTime/histogram")),
        whenGetFirstResponseTimeCumuative: createFakePostResponder(fakeHttp, "".concat(base, "/firstResponseTime/cumulative")),
        whenGetChatRepliesHistogram: createFakePostResponder(fakeHttp, "".concat(base, "/chatReplies/histogram")),
        whenGetChatRepliesCumuative: createFakePostResponder(fakeHttp, "".concat(base, "/chatReplies/cumulative")),
        whenGetSatisfactionScoreCumulative: createFakePostResponder(fakeHttp, "".concat(base, "/satisfactionRate/cumulative")),
        whenGetSatisfactionScoreHistogram: createFakePostResponder(fakeHttp, "".concat(base, "/satisfactionRate/histogram")),
        whenGetChatServieLevel: createFakePostResponder(fakeHttp, "".concat(base, "/chatServiceLevel")),
    };
    return __assign(__assign({}, api), handler);
};
//# sourceMappingURL=testkit.js.map